module.exports = __webpack_public_path__ + "assets/img/3.ebc65cf0.jpg";